import React, { Fragment, useEffect } from "react";

interface CalendlyProps {}

function Calendly(props: CalendlyProps) {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    head?.appendChild(script);
  }, []);

  return (
    <Fragment>
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/geraldvindasa/30min?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=efb810"
        style={{ minWidth: "320px", height: "700px" }}
      />
    </Fragment>
  );
}

export default Calendly;
